import React, {
    useState, useEffect, useRef, useLayoutEffect, useCallback
} from 'react';
import { Modal } from 'react-bootstrap';
import store from '../../../redux/reducers/reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import queryString from 'query-string';
import { connect, useDispatch } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';
import { captureException } from '@sentry/react';
import { isMobileSafari } from 'react-device-detect';
import axios from 'axios';
import {
    setChatGalleryActiveMessage,
    setChatGalleryFilter,
    setChatGalleryMessages,
    setChatGallerySource,
    setShowChatGallery,
} from '../../../redux/actions/chatGallery';
import { orange, grey } from '@mui/material/colors';

import {
    setActiveUserR,
    updateConvListR,
    appendConvListR,
    setConvIndexR,
    updateUnreadConvListR,
    updateShowMsgLoaderR,
    updateActiveConvR,
    setStashModal,
    setBroadcastModal,
    setUser,
    setSidebarBusy,
    updateUserFilter,
    updateMessengerSearchFilter
} from '../../../redux/actions';
import Avatar from '../../common/Avatar';
import { FOLLOW_STATUS, ROLES } from '../../utils/constants';
import MassMessageStatsModal from './mass-message-stats';
import { setStash, setStashShow, setStashSidebar } from '../../../redux/actions/stash';
import useDebounce from '../../utils/useDebounceV2';
import useOnlineHook from '../../utils/useOnlineHook';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { addChunkOnlinePresence, setOnlinePresence } from '../../../redux/actions/user';
import { resetPersonalNote, setPersonalNoteIsOpen } from "../../../redux/actions/notes";
import ChatGallery from "../../common/ChatGallery";
import SidebarSkeleton from './SidebarSkeleton';
import { Tooltip } from '@mui/material';
import { useHistory } from 'react-router';

const MessengerSideBar = ({
    setStashShow,
    userInformation,
    getUserInformation,
    addChunkOnlinePresence,
    setSidebarBusy,
    updateUserFilter,
    updateMessengerSearchFilter,
    sidebarBusy,

    setActive,
    active = null,
    latestMsg = null,
    activeConv,
    setActiveConv,
    setMsgModalIsOpen,
    setShowMobileChat,
    setActiveUser,
    updateConvList,
    conv_list,
    appendConvList,
    setConvIndex,
    updateUnreadConvList,
    updateActiveConv,
    setStashSidebar,
    setBroadcastModal,
    loginUser,
    refreshConvList,
    setRefreshConvList,
    setOnlinePresence,
    userFilter,
    showChatGallery,
    chatGallerySource,
    messengerSearchFilter,
}) => {
    useOnlineHook();

    const dispatch = useDispatch();
    const history = useHistory();

    // CONSTANT VARIABLES
    const DEBOUNCE_DELAY = 400;
    const LOGGEDIN_USER = localStorage.getItem('loggedin_user');

    const [users, setUsers] = useState([]);
    const [defActive, setDefActive] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pauseLoadMore, setpauseLoadMore] = useState(false); // used to disable auto trigger of load more when loading messages
    const [messageEnd, setMessageEnd] = useState(false);
    const [isFirst, setIsFirst] = useState(false);
    const [gettingUsers, setGettingUsers] = useState(false);

    const listInnerRef = useRef();
    const cancelTokenSource = useRef();

    const cancelRequest = useCallback(() => {
        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel('Abort request');
        }
    }, []);

    $('.messenger-sideheader .stash_sales').unbind().click(() => {
        $('.stash_sales_clicker').trigger('click');
    });

    const getFollowers = async (
        source,
        filter_changed = false,
        resetBroadcast = false,
        changeIndex = true,
        filter_type = userFilter,
        searchText = messengerSearchFilter,
        perPage = 30
    ) => {
        setpauseLoadMore(true);

        const parsed = queryString.parse(location.search);
        let users_len = conv_list.length;
        let page_num = 1;

        if (users_len > 0) {
            page_num = 1 + Math.ceil(users_len / perPage);
        } else {
            page_num = 1;
        }

        if (resetBroadcast || filter_changed) {
            users_len = 0;
            page_num = 1;
            setMessageEnd(false);
        }

        setGettingUsers(true);
        setSidebarBusy(true);

        let response, timeoutId;
        try {
            response = await axios.get('/api/fetchConvs', {
                params: {
                    conversation_id: parsed.conversation_id,
                    user_filter: filter_type,
                    user_skip: users_len,
                    search_text: searchText,
                    page: page_num,
                    sidebar: true,
                },
                cancelToken: source.token
            });

            const { data } = response;

            let user_list = data.data;
            setpauseLoadMore(false);
            setGettingUsers(false);
            setRefreshConvList(false);

            if (filter_changed || resetBroadcast) {
                setUsers([...data.data]);

                if (userFilter === 'unread') {
                    user_list = user_list.sort(compareLatestUnreadMessageDate);
                }

                updateConvList(user_list);
                if (user_list.length == perPage) { // reset load more if there's more
                    setMessageEnd(false);
                }
            } else if (users.length == 0) {
                setUsers([...data.data]);

                if (userFilter === 'unread') {
                    user_list = user_list.sort(compareLatestUnreadMessageDate);
                }

                updateConvList(user_list);
            } else {
                setUsers([...users, ...data.data]);
                appendConvList(data.data);
            }

            if (data.data.length < 10) {
                setMessageEnd(true);
            }
            setSidebarBusy(false);
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled: ', error.message);
            }
            setGettingUsers(false);
            captureException(typeof (error) === 'object' ? (error?.message ?? error) : error);
            setpauseLoadMore(false);
            setSidebarBusy(false);
        } finally {
            if (source) {
                source.cancel();
            }
        }
    };

    const debouncedGetFollowersOnFilterChange = useDebounce(() => {
        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        getFollowers(source, false, true);
    }, DEBOUNCE_DELAY);

    const debouncedSearchFunction = useDebounce(() => {
        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        getFollowers(source, true);
    }, DEBOUNCE_DELAY);

    const debouncedRefetch = useDebounce(() => {
        refetch();
    }, DEBOUNCE_DELAY);

    useEffect(() => {
        let mounted = true;
        debouncedSearchFunction();

        return () => {
            mounted = false;
        };
    }, [messengerSearchFilter]);

    $('.messenger-sideheader .stash-sales-icon').unbind().click(() => {
        $('.stash_sales_clicker').trigger('click');
    });

    useDidMountEffect(() => {
        let mounted = true;
        debouncedGetFollowersOnFilterChange();

        return () => {
            mounted = false;
        };
    }, [userFilter]);


    useDidMountEffect(() => {
        let mounted = true;
        if (latestMsg) {
            if (cancelTokenSource.current) {
                cancelRequest();
            }

            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();
            cancelTokenSource.current = source;

            getFollowers(source);
        }

        return () => {
            mounted = false;
            if (latestMsg) {
                cancelRequest();
            }
        };
    }, [latestMsg]);

    const clearSearchText = (e) => {
        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        updateMessengerSearchFilter('');
        getFollowers(source, true);
    };

    const handleSearchChange = (event) => {
        updateMessengerSearchFilter(event.target.value);
    };

    // useEffect(() => {
    //     if (gettingUsers && isMobile) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = 'auto';
    //     }

    //     return () => {
    //         document.body.style.overflow = "auto";
    //     };
    // }, [gettingUsers]);

    const conversationScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (((scrollTop + clientHeight) >= scrollHeight - 60) && !pauseLoadMore) {
                if (!messageEnd) {
                    if (cancelTokenSource.current) {
                        cancelRequest();
                    }

                    const cancelToken = axios.CancelToken;
                    const source = cancelToken.source();
                    cancelTokenSource.current = source;

                    getFollowers(source);
                }
            }
        }
    };

    const handleUserFilterChange = (filter_type) => {
        if (userFilter !== filter_type) {
            updateConvList([]);
            updateUserFilter(filter_type);
        }
    };

    const updateActive = (user, conv, index = 0) => {
        // console.log({ user, conv, index });
        dispatch(setShowChatGallery(false));
        dispatch(setChatGalleryFilter('all'));
        dispatch(setChatGalleryMessages([]));
        dispatch(setChatGalleryActiveMessage([]));

        dispatch(resetPersonalNote());

        updateUnreadConvList(conv_list, index); // update status to read
        if (conv_list.length > 0) {
            setConvIndex(index);
        }
        setDefActive(user);

        if (active !== user && defActive !== user) {
            setActive(user);
            setActiveUser(user);
            localStorage.setItem('other_user', user);
        }
        setActiveConv(conv);
        updateActiveConv(conv);

        if (window.innerWidth < 768) {
            if (!isFirst) setShowMobileChat(true);

            setIsFirst(false);
        }
    };

    const handleOpenStash = (e) => {
        e.preventDefault();
        setStashSidebar(true);
        setStashShow(true);
    };

    const handleOpenBroadcast = () => {
        setBroadcastModal(true);
        setMsgModalIsOpen(true);
        history.push('/messages/newmessage');
    };

    /**
     * I've commented the following functions for now because they restrict the height of the messenger sidebar on mobile devices which creates a white space at the bottom:
     * - handleWindowResize
     * - useLayoutEffect
     */
    // const handleWindowResize = () => {
    //     const parentHeight = $('.messenger-container').height();
    //     const headerHeight = $('.messenger-sideheader').outerHeight();

    //     $('.user-list').css({
    //         'max-height': parentHeight - headerHeight,
    //     });
    // };

    // useLayoutEffect(() => {
    //     handleWindowResize();

    //     window.addEventListener('resize', handleWindowResize);

    //     return () => {
    //         window.removeEventListener('resize', handleWindowResize);
    //     };
    // }, []);

    useDidMountEffect(() => {
        if (refreshConvList) {
            if (cancelTokenSource.current) {
                cancelRequest();
            }

            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            getFollowers(source, false, true);
        }

        return () => {
            if (refreshConvList) {
                cancelRequest();
            }
        };
    }, [refreshConvList]);

    const refetch = () => {
        const filter = store.getState().message.userFilter;
        const searchText = store.getState().message.messengerSearchFilter;

        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;
        getFollowers(source, false, true, false, filter, searchText);
    };

    const offlineAction = e => {
        const filter = store.getState().message.userFilter;

        if (filter == 'online') {
            const convList = store.getState().message.convList;
            const tmpConvList = JSON.parse(JSON.stringify(convList));
            const index = tmpConvList.findIndex(conv => conv.rec_id == e.detail.user_id || conv.sender_id == e.detail.user_id);

            if (index >= 0) {
                tmpConvList.splice(index, 1);
                updateConvList([...tmpConvList]);
            }
        }
    };

    useEffect(() => {
        let mounted = true;
        handleUserFilterChange('all');

        if (!userInformation) {
            getUserInformation();
        }

        const handleDispatchedRefetch = () => {
            debouncedRefetch();
        };

        const handleOfflineEvent = (e) => {
            offlineAction(e);
        };

        window.addEventListener('chatmessage/fetchConvs', handleDispatchedRefetch);
        window.addEventListener('onlineHook/offline', handleOfflineEvent);
        window.addEventListener('onlineHook/online', handleOnlineEvent);

        return () => {
            mounted = false;
            window.removeEventListener('chatmessage/fetchConvs', handleDispatchedRefetch);
            window.removeEventListener('onlineHook/offline', handleOfflineEvent);
            window.removeEventListener('onlineHook/online', handleOnlineEvent);
            updateMessengerSearchFilter('');
        };
    }, []);

    useEffect(() => {
        let mounted = true;
        if (conv_list && conv_list.length > 0) {
            const online = conv_list.map(conv => {
                let onlineStatus = Boolean(parseInt(conv.su_online_status, 10));
                let otherUserId = conv.follower == LOGGEDIN_USER
                    ? conv.creator
                    : conv.follower;

                if (conv.follower == LOGGEDIN_USER) {
                    onlineStatus = Boolean(parseInt(conv.pu_online_status, 10));
                }

                if (onlineStatus) {
                    return parseInt(otherUserId, 10);
                }
            }).filter(item => item && item > 0);

            const uniqueOnline = online.filter((item, index) => online.indexOf(item) == index);

            setOnlinePresence([...uniqueOnline]);
        } else {
            setOnlinePresence([]);
        }

        return () => {
            mounted = false;
        };
    }, [conv_list]);

    function compareLatestUnreadMessageDate(a, b) {
        return a.created_at < b.created_at;
    }

    const handleChatGallery = (e, state) => {
        e.preventDefault();
        dispatch(setShowChatGallery(state));
        dispatch(setChatGallerySource('sidebar'));
    };

    const handleShowChatGallery = () => {
        return showChatGallery && chatGallerySource === 'sidebar';
    };

    const parseOtherUserInfo = (conv) => {
        return {
            id: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.creator
                : conv.follower,
            login: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.pu_login
                : conv.su_login,
            online_status: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.pu_online_status
                : conv.su_online_status,
            profile_photo_updated_at: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.pu_profile_photo_updated_at
                : conv.su_profile_photo_updated_at,
            profile_pic: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.pu_profile_pic
                : conv.su_profile_pic,
            deleted_at: conv.follower == LOGGEDIN_USER && conv.follower != 1
                ? conv.pu_deleted_at
                : conv.su_deleted_at,
        };
    };

    const handleOnlineEvent = () => {
        refetch();
    };


    return <>
        {handleShowChatGallery() && <Modal show={showChatGallery} className={'chat-gallery-modal'}>
            <Modal.Header className={'chat-gallery-header'}>
                <div className="title">
                    <span style={{ fontWeight: 'bold', fontSize: '20px' }}>Gallery</span>
                    <button className={'close'} type={'button'} onClick={(e) => handleChatGallery(e, false)}>
                        <span style={{ fontWeight: '400' }}><i className="far fa-times" aria-hidden="true"></i></span>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body>
                <ChatGallery
                    key={`${Math.round()}`}
                    user={loginUser}
                />
            </Modal.Body>
        </Modal>
        }
        <div className="messenger-sidebar">
            <div className={`messenger-sidebar-preloader ${loading ? 'show-me' : ''}`} />
            <div className="messenger-sideheader">
                <div className="chat-new-msg-cont">

                    <div className="side-icons-cont" style={{ display: 'none' }}>
                        {loginUser && loginUser.role === ROLES.PU
                            && <div className="stash-sales-icon"><i className="fa-regular fa-square-dollar" /></div>}
                        {loginUser && loginUser.role === ROLES.PU
                            && <MassMessageStatsModal />}
                        <div className="new-message-icon" onClick={handleOpenBroadcast}><i className="fa-regular fa-pen-to-square" /></div>
                        <div className="clear_b" />
                    </div>

                    <div className="d-flex justify-content-around">
                        <button className="chat-new-msg chat-new-msg-top m-1" onClick={handleOpenBroadcast}>
                            <span><i className="fa-regular fa-pen-to-square" /></span>
                            {' '}
                            New Message
                        </button>
                        {
                            loginUser && loginUser.role === ROLES.SU && <>
                                <button
                                    type="button"
                                    className="chat-gallery-sidebar m-1"
                                    onClick={(e) => handleChatGallery(e, true)}
                                    style={{ width: '60%' }}
                                >
                                    <span><i className="fa-light fa-image"></i></span>
                                    {' '}
                                    Gallery
                                </button>
                            </>
                        }
                        {loginUser && loginUser.role === ROLES.PU && (
                            <button
                                type="button"
                                className="stash-sidebar m-1"
                                onClick={handleOpenStash}
                            >
                                <span><FontAwesomeIcon icon={['fas', 'photo-video']} /></span>
                                {' '}
                                Stash
                            </button>
                        )}
                    </div>

                    {loginUser && loginUser.role === ROLES.PU
                        && (
                            <span className="stash_sales chat-new-msg stats-btn" style={{ display: 'none' }}>
                                <FontAwesomeIcon icon={['fas', 'dollar-sign']} />
                                &nbsp;Sales
                            </span>
                        )}
                </div>
                <div className="messenger-side-search-cont">
                    {loginUser && loginUser.role === ROLES.PU
                        && <div className="stash-sales-icon"><i className="fa-regular fa-square-dollar" /></div>}
                    {loginUser && loginUser.role === ROLES.PU
                        && <MassMessageStatsModal />}
                    <div
                        className={`d-flex justify-content-around messenger-side-search ${loginUser && loginUser.role === ROLES.PU ? '' : ' messenger-side-search-full'}`}
                    >
                        <input
                            type="text"
                            name="search"
                            onChange={handleSearchChange}
                            value={messengerSearchFilter}
                            placeholder="Search"
                        />
                        {
                            messengerSearchFilter && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                        }
                    </div>
                </div>
                <div className="chat-tabs">
                    <ul className="nav nav-tabs">
                        <li onClick={() => handleUserFilterChange('all')} className={`convo_type ${userFilter == 'all' ? 'active' : ''}`}><span>All</span></li>
                        <li onClick={() => handleUserFilterChange('unread')} className={`convo_type ${userFilter == 'unread' ? 'active' : ''}`}><span>Unread</span></li>
                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('unsubscribed')} className={`convo_type ${userFilter == 'unsubscribed' ? 'active' : ''}`}><span>Unsubscribed</span></li>
                        }
                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('tips')} className={`convo_type ${userFilter == 'tips' ? 'active' : ''}`}><span>Tips</span></li>
                        }
                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('ppvs')} className={`convo_type ${userFilter == 'ppvs' ? 'active' : ''}`}><span>PPVs</span></li>
                        }

                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('expired')} className={`convo_type ${userFilter == 'expired' ? 'active' : ''}`}><span>Expired</span></li>
                        }

                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('favourites')} className={`convo_type ${userFilter == 'favourites' ? 'active' : ''}`}><span>Favourites</span></li>
                        }

                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('paid')} className={`convo_type ${userFilter == 'paid' ? 'active' : ''}`}><span>Paid Subs</span></li>
                        }

                        {
                            [ROLES.PU, ROLES.ADMIN].includes(loginUser.role) && <li onClick={() => handleUserFilterChange('free')} className={`convo_type ${userFilter == 'free' ? 'active' : ''}`}><span>Free Subs</span></li>
                        }

                        <li onClick={() => handleUserFilterChange('online')} className={`convo_type ${userFilter == 'online' ? 'active' : ''}`}><span>Online</span></li>
                    </ul>
                </div>
            </div>
            <div
                id="user-list-cont"
                className={`user-list messenger-listing${isMobileSafari ? ' safari' : ''}`}
                onScroll={conversationScroll}
                ref={listInnerRef}
            >
                <ul className="list-unstyled" id="myUL">
                    {
                        conv_list.map((conv, index) => {
                            const otherUserInfo = parseOtherUserInfo(conv);

                            return <li
                                key={index}
                                className={`li messenger-user ${conv.conversation_id == activeConv ? 'selected' : ''}`}
                                onClick={() => updateActive(parseInt(otherUserInfo.id, 10), conv.conversation_id, index)}
                            >
                                <span>
                                    <div className="um-message-conv-pic usr-pro-pic">
                                        <Avatar
                                            size="40"
                                            pu={{
                                                id: otherUserInfo.id,
                                                profile_pic: Boolean(parseInt(otherUserInfo.profile_pic)),
                                                is_online: Boolean(parseInt(otherUserInfo.online_status)),
                                                photo_updated_at: otherUserInfo.profile_photo_updated_at
                                            }}
                                            story={false}
                                            showOnline
                                        />
                                    </div>
                                </span>
                                <span className={`li messenger-user um-message-conv-item-det ${conv.rec_id == activeConv ? 'um-message-conv-item active' : 'um-message-conv-item'}`}>
                                    <div className="user-msg">
                                        <span className="um-message-conv-name usrname">
                                            {otherUserInfo.login}
                                            {' '}
                                            {
                                                conv.creator == LOGGEDIN_USER && Boolean(parseInt(conv.favourites, 10))
                                                    ? <FontAwesomeIcon icon={['fas', 'star']} />
                                                    : null
                                            }
                                            {
                                                conv.follow_status == FOLLOW_STATUS.UNSUBSCRIBED
                                                    ? <span style={{
                                                        color: orange[500],
                                                        float: 'right'
                                                    }}>
                                                        <Tooltip title="Expired">
                                                            <i className="fa-regular fa-triangle-exclamation"></i>
                                                        </Tooltip>
                                                    </span>
                                                    : null
                                            }
                                            {
                                                conv.muteb == 1 || conv.mutea == 1
                                                    ? <span style={{
                                                        color: grey[500],
                                                        float: 'right',
                                                        marginLeft: '4px'
                                                    }}>
                                                        <Tooltip title={`${conv.su_login == userInformation.login ? conv.pu_login : conv.su_login} has muted you from sending or receiving messages`}>
                                                            <i className="fa-regular fa-message-slash"></i>
                                                        </Tooltip>
                                                    </span>
                                                    : null
                                            }
                                        </span>
                                        <div
                                            className={
                                                `lst-msg ${conv.status == 0 && conv.rec_id == LOGGEDIN_USER
                                                    ? 'lst-msg-unread'
                                                    : ''}
                                                ${conv.price > 0
                                                    ? ' ppv_blue_text'
                                                    : ''}`
                                            }
                                        >
                                            {
                                                conv.sender_id == LOGGEDIN_USER
                                                    ? 'You: '
                                                    : ''
                                            }

                                            {
                                                conv.price > 0 || (conv.message_media_id && parseInt(conv.message_media_id) > 0)
                                                    ? <i className="fa-solid fa-photo-film" style={{ marginRight: '4px' }}></i>
                                                    : null
                                            }

                                            {
                                                <span
                                                    className="msg-span"
                                                    dangerouslySetInnerHTML={{ __html: conv.price > 0 ? ' Pay Per View' : conv.message }}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="date">
                                        {
                                            moment().format('L') == moment.utc(conv.created_at).local().format('L')
                                                ? moment
                                                    .utc(conv.created_at)
                                                    .local()
                                                    .format('h:mm a')
                                                : moment
                                                    .utc(conv.created_at)
                                                    .local()
                                                    .format('MMM DD YYYY')
                                        }
                                    </div>
                                </span>
                            </li>;
                        })
                    }
                </ul>

                {
                    sidebarBusy && conv_list.length == 0
                        ? <React.Fragment>
                            <SidebarSkeleton />
                            <SidebarSkeleton
                                width="50%"
                            />
                            <SidebarSkeleton
                                width="70%"
                            />
                        </React.Fragment>

                        : null
                }
            </div>
        </div>
    </>;
};

function mapStateToProps(state) {
    return {
        show: state.stash.show,
        // stash: state.stash,
        conv_list: state.message.convList,
        showMsgLoader: state.message.showMsgLoader,
        stashModal: state.message.stashModal,
        stashSidebar: state.stash.stashSidebar,
        broadcastModal: state.message.broadcastModal,
        userInformation: state.user.user,
        userFilter: state.message.userFilter,
        activeConv: state.message.activeConv,
        showChatGallery: state.chatGallery.show,
        chatGallerySource: state.chatGallery.source,
        messengerSearchFilter: state.message.messengerSearchFilter,
        sidebarBusy: state.message.sidebarBusy,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setActiveUser: (activeUser) => dispatch(setActiveUserR(activeUser)),
        updateConvList: (convList) => dispatch(updateConvListR(convList)),
        appendConvList: (payload) => dispatch(appendConvListR(payload)),
        setConvIndex: (convIndex) => dispatch(setConvIndexR(convIndex)),
        updateUnreadConvList: (convList, convIndex) => dispatch(updateUnreadConvListR(convList, convIndex)),
        updateShowMsgLoader: (showMsgLoader) => dispatch(updateShowMsgLoaderR(showMsgLoader)),
        updateActiveConv: (activeConv) => dispatch(updateActiveConvR(activeConv)),
        setStashModal: (stashModal) => dispatch(setStashModal(stashModal)),
        setStashSidebar: (stashSidebar) => dispatch(setStashSidebar(stashSidebar)),
        setBroadcastModal: (broadcastModal) => dispatch(setBroadcastModal(broadcastModal)),
        setStash: (stash) => dispatch(setStash(stash)),
        setStashShow: (payload) => dispatch(setStashShow(payload)),
        getUserInformation: (payload) => dispatch(setUser(payload)),
        addChunkOnlinePresence: (payload) => dispatch(addChunkOnlinePresence(payload)),
        setSidebarBusy: (payload) => dispatch(setSidebarBusy(payload)),
        setOnlinePresence: (payload) => dispatch(setOnlinePresence(payload)),
        updateUserFilter: (payload) => dispatch(updateUserFilter(payload)),
        updateMessengerSearchFilter: (payload) => dispatch(updateMessengerSearchFilter(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessengerSideBar);
